export default __webpack_public_path__ + "static/media/KK_P_Right_Top_aCrop.1e587f40.svg";